import React from 'react';
import CommonFunctions from '../RegCommon/CommonFunctions';
import EventcodeFunctions from '../RegCommon/EventcodeFunctions';

class RegitemRadio extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            regitem: props.regitem,
            groupname: props.groupname,
            disableregitem: props.disableregitem,
            signupsremaining: props.signupsremaining,
            dataloaded: false
        }
    }

    render() {
        return (
            <div>
                {this.renderRadioInput(this.state.regitem, this.state.groupname, this.state.disableregitem)}
                {this.renderSignupsRemaining(this.state.signupsremaining)}
            </div>
        );
    }
    isUserSelectedItemFromThisGroup(groupname) {
        var result = false;
        global.$regitems.map(item => {
            if (item.isChecked == true && item.groupname == groupname) {
                result = true;
            }
        })
        return result;
    }
    renderRadioInput(regitem, groupname, disableregitem) {
        // If user already registered for this reg item make this item as selected
        // var itemSelected = this.isUserSelectedItemFromThisGroup(groupname);
        if (CommonFunctions.isUserAlreadyRegisteredForThisItem(regitem.name)) {
            return (
                this.renderRegisteredItems(regitem, groupname)
            )
        }
        else {
            if (CommonFunctions.isUserLoggedin()) {
                return (
                    this.renderItemsAfterLogin(regitem, groupname)
                )
            }
            else {
                return (
                    <input
                        type={regitem.inputtype}
                        className="reg-radio"
                        name={groupname}
                        value={regitem.name}
                        key={regitem.data5}
                        onChange={() => this.handleRadioButtons(regitem, groupname)}
                    />
                )
            }
        }

    }

    renderRegisteredItems(item, groupname) {
        if (global.$loggedinuserregitems != null) {
            var regitems = global.$loggedinuserregitems
            //console.log(regitems);
            //console.log("Reg option from login");
            regitems = regitems.split(",");
            return regitems.map(regitem => {
                item.name = item.name.trim();
                //console.log(regitem, item.name, regitem.includes(item.name));
                return (
                    <div>
                        {
                            regitem.startsWith(item.name) ?
                                (
                                    // <input
                                    //     type="radio"
                                    //     className="reg-radio"
                                    //     name={groupname}
                                    //     value={regitem.name}
                                    //     key={regitem.data5}
                                    //     // onChange={() => this.handleRadioButtons(regitem, groupname)}
                                    //     // checked
                                    //     disabled
                                    // />
                                    <b className="reg-radio">Registered</b>
                                )
                                :
                                (
                                    ''
                                )
                        }
                    </div>
                )
            })
        }
    }

    renderItemsAfterLogin(regitem, groupname) {
       //console.log(groupname)
        if (groupname.includes("attendee") || groupname.includes("Attendee") || groupname.includes("Booth Choice")) // first group
        {
            if (EventcodeFunctions.isTravconExhibitor(global.$code)) {
                return (
                    <input
                        type={regitem.inputtype}
                        className="reg-radio"
                        name={groupname}
                        value={regitem.name}
                        key={regitem.data5}
                        onChange={() => this.handleRadioButtons(regitem, groupname)}
                    />
                )
            }
            else if (EventcodeFunctions.isTravconAttendee(global.$code)) {
                return (
                    <input
                        type={regitem.inputtype}
                        className="reg-radio"
                        name={groupname}
                        value={regitem.name}
                        key={regitem.data5}
                        onChange={() => this.handleRadioButtons(regitem, groupname)}
                    />
                )
            }
            else {
                return (
                    <input
                        type={regitem.inputtype}
                        className="reg-radio"
                        name={groupname}
                        value={regitem.name}
                        key={regitem.data5}
                        onChange={() => this.handleRadioButtons(regitem, groupname)}
                        disabled
                    />
                )
            }
        }
        else if (groupname.includes("guest") || groupname.includes("Guest")) {
            if (global.$loggedinuser.guests != "" && global.$loggedinuser.guests != " ") {
                return (
                    <input
                        type={regitem.inputtype}
                        className="reg-radio"
                        name={groupname}
                        value={regitem.name}
                        key={regitem.data5}
                        onChange={() => this.handleRadioButtons(regitem, groupname)}
                        disabled
                    />
                )
            }
            else {
                return (
                    <input
                        type={regitem.inputtype}
                        className="reg-radio"
                        name={groupname}
                        value={regitem.name}
                        key={regitem.data5}
                        onChange={() => this.handleRadioButtons(regitem, groupname)}
                    />
                )
            }
        }
        else {
            return (
                <input
                    type={regitem.inputtype}
                    className="reg-radio"
                    name={groupname}
                    value={regitem.name}
                    key={regitem.data5}
                    onChange={() => this.handleRadioButtons(regitem, groupname)}
                />
            )
        }
    }

    renderSignupsRemaining(signupsremaining) {
        return (
            <div className="reg-signups-remaining">{signupsremaining}</div>
        )
    }

    handleRadioButtons(selected, groupname) {
        //console.log(selected);
        this.updateSelectedRegItemRadio(selected, groupname);
        //console.log(global.$regitems)
    }

    updateSelectedRegItemRadio(selected, groupname) {
        global.$regitems.map(regitem => {
            //console.log(regitem);
            // Check for radio input type and then update status
            if (regitem.groupname == groupname && CommonFunctions.isRadioInput(regitem)) {
                //console.log(regitem);
                if (regitem.data5 == selected.data5) {
                    //console.log(regitem);
                    regitem.isChecked = true;
                    regitem.itemprice = selected.amount;
                }
                else {
                    regitem.isChecked = false;
                    regitem.itemprice = 0;
                }
            }
        })
        this.props.refreshComponent();
        //this.setState({dataloaded: true})
    }
}

export default RegitemRadio;